import { styled } from "../../../styled-components";
import { ButtonStyle } from "../../../ui/views/button/button-view-style";

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;

    flex-grow: 1;

    padding-top: ${p => p.theme.pageMarginMedium}px;
    padding-bottom: ${p => p.theme.pageMarginMedium}px;
`;

export const BodyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    flex-grow: 1;

    padding: 0 30px;
`;

export const AppInfoBodyWrapper = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    height: inherit;

    &:nth-child(1) {
        width: 100%;
    }
`;

export const FeedbackBodyWrapper = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    height: inherit;
    margin-top: 75px;
`;

export const FooterWrapper = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    padding: 0 30px;

    margin-bottom: 15px;

    color: inherit;
    :hover {
        color: inherit;
        text-decoration: none;
    }
`;

export const QRCodeWrapper = styled.div`
    width: 260px;
    height: 260px;
    padding: 24px;
    background-color: white;

    border: 2px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;

    margin-bottom: 100px;
`;

export const Title = styled.div`
    color: ${p => p.theme.fgColorDark};
    ${p => p.theme.fontStyles.AccentHeader3}
    text-align: center;
    margin-top: 20px;
`;

export const Subtitle = styled.div`
    text-align: center;
    color: ${p => p.theme.fgColorDark};
    ${p => p.theme.fontStyles.Body4}

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    padding: 0 30px;

    margin-bottom: 15px;

    padding-bottom: var(--safe-area-inset-bottom);
`;

export const CopyButton = styled(ButtonStyle)`
    width: 152px;
    margin-top: 30px;
    cursor: pointer;

    :active {
        filter: brightness(0.8);
    }
`;

export const GlideLogo = styled.div`
    svg {
        fill: ${p => p.theme.fgColorDark};
    }
`;

export const Footer = styled.div`
    text-align: center;
    ${p => p.theme.fontStyles.Header5}
    color: ${p => p.theme.fgColorLight};
    margin-top: 10px;

    padding-bottom: var(--safe-area-inset-bottom);
`;

export const GlideSpan = styled.span`
    color: ${p => p.theme.primaryAccentColor};
`;
